import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface VerificationState {
  status: "idle" | "loading" | "verified" | "failed";
  error: string | null;
}

export const initialState: VerificationState = {
  status: "idle",
  error: null,
};

const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    verifyStart(state) {
      state.status = "loading";
      state.error = null;
    },
    verifySuccess(state) {
      state.status = "verified";
    },
    verifyFailure(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.error = action.payload;
    },
    resetVerification(state) {
      state.status = "idle";
      state.error = null;
    },
  },
});

export const {
  verifyStart,
  verifySuccess,
  verifyFailure,
  resetVerification,
} = verificationSlice.actions;
export default verificationSlice.reducer;
